import * as AddToBasketEvent from '@ori-events/add-to-basket';
import * as ToggleFavorite from '@ori-events/toggle-favorite';
import * as UserAction from '@ori-events/user-action';
import type { RevieveProduct, RevieveTrackingPayload, RevieveTrackingProductItem } from 'revieve';

import {
  TRACKING_CATEGORY_PRODUCT_RECOMMENDATION,
  TRACKING_TITLE_CONDITIONS,
  TRACKING_TITLE_SELFIE,
  USER_ACTION_DIAGNOSIS_COMPLETED,
  USER_ACTION_DIAGNOSIS_STARTED,
  WITHOUT_SELFIE,
  WITH_SELFIE,
} from './constants';

export const addToBasket = ({ id }: RevieveProduct) =>
  window.dispatchEvent(
    new CustomEvent<AddToBasketEvent.Data>(AddToBasketEvent.Name, {
      detail: { itemCode: id, quantity: 1 },
    }),
  );

export const toggleFavorite = ({ id }: RevieveProduct) =>
  window.dispatchEvent(
    new CustomEvent<ToggleFavorite.Data>(ToggleFavorite.Name, {
      detail: { code: id },
    }),
  );

export const sendUserEvents = ({ payload }: RevieveTrackingPayload) => {
  if (payload.payload) {
    const { category, items } = payload.payload;
    if (category === TRACKING_CATEGORY_PRODUCT_RECOMMENDATION && items) {
      UserAction.dispatch([
        ...USER_ACTION_DIAGNOSIS_COMPLETED,
        items.map((p: RevieveTrackingProductItem) => p.item_id).join(','),
      ]);
    }
  }
  switch (payload.title) {
    case TRACKING_TITLE_CONDITIONS:
      UserAction.dispatch([...USER_ACTION_DIAGNOSIS_STARTED, WITHOUT_SELFIE]);
      break;
    case TRACKING_TITLE_SELFIE:
      UserAction.dispatch([...USER_ACTION_DIAGNOSIS_STARTED, WITH_SELFIE]);
      break;
    default:
      break;
  }
};
